import DocumentLibrary from "../components/DocumentLibrary";

export default function Annexure() {
  return (
    <DocumentLibrary
      docType="annexure"
      title="Annexure"
      subtitle="All OA-linked documents"
      accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx,.xls,.xlsx,.csv,.txt,.zip"
      columns={["OA Number", "Customer", "File Name", "File Type", "File Size"]}
      metaFields={[
        { key: "oaNumber", label: "OA Number", required: true },
        { key: "customerName", label: "Customer" },
      ]}
    />
  );
}
